import React, { FunctionComponent } from "react";
import { InputProps, inputStyle } from "Shared/Form/Input";
import styled from "styled-components";
import MaskedInput from "react-text-mask";

interface SSNInputProps extends InputProps {
    isUS?: boolean;
}

const Input: FunctionComponent<SSNInputProps> = (props) => {
    const { error, hasError, hasLabel, isUS = true, ...rest } = props;

    return (
        <MaskedInput
            {...rest}
            mask={
                isUS
                    ? [/\d/, /\d/, /\d/, "-", /\d/, /\d/, "-", /\d/, /\d/, /\d/, /\d/]
                    : [/\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/]
            }
            guide={false}
            placeholder={`${isUS ? "999-99-9999" : "999-999-999"}`}
        />
    );
};

const SSNInput = styled(Input)<InputProps>`
    ${inputStyle};
`;

export default SSNInput;
